/**
 * Utilidades para categorías de gastos.
 * Incluye mapeo de IDs legacy a nombres amigables.
 */

// Solo para "Otros" (gastos sin categoría asignada)
const LEGACY_OTHER = "_other";

/**
 * Resuelve el ID de categoría al nombre a mostrar.
 * Usa las categorías que el usuario agregó; si no hay coincidencia, muestra "Sin categoría".
 * @param {string} categoryValue - ID de la categoría (ej: "cat_xxx")
 * @param {Array<{id: string, name: string}>} customCategories - Categorías personalizadas
 * @returns {string} Nombre amigable para mostrar
 */
export const getCategoryLabel = (categoryValue, customCategories = []) => {
  if (!categoryValue) return "";
  if (categoryValue === LEGACY_OTHER) return "Otros";
  const cat = (customCategories || []).find((c) => c.id === categoryValue);
  return cat ? cat.name : "Sin categoría";
};
